// extracted by mini-css-extract-plugin
export var fadeInOut = "_1y-3";
export var icon = "_1y-4";
export var savedIndicator = "_1y-2";
export var savingIndicator = "_1y-0";
export var spin = "_1y-1";